import type { TApiSupportingFile } from "@/apis/proda_finance";
import type { TSupportingFile } from "@/store";

export function mapApiSupportingFileToStore(f: TApiSupportingFile): TSupportingFile {
    return {
        id: f.id,
        dealId: f.deal_id,
        dealName: f.deal_name,
        period: f.period ?? null,
        financialFileId: f.financial_file_id,
        financialFileName: f.financial_file_name,
        friendlyName: f.friendly_name,
        originalFilename: f.original_filename,
        fileSizeBytes: f.file_size_bytes,
        contentType: f.content_type,
        contentHash: f.content_hash,
        notes: f.notes,
        uploadedById: f.uploaded_by_id,
        uploadedByName: f.uploaded_by_name,
        createdAt: f.created_at,
        updatedAt: f.updated_at,
        rowVersion: f.row_version,
        canEdit: f.can_edit,
    };
}
